import fs from 'node:fs'
import path from 'node:path'

export function detectTailwind(cwd: string): boolean {
  const cssFiles = ['globals.css', 'app.css', 'index.css'].flatMap((f) => [
    path.join(cwd, 'src', 'app', f),
    path.join(cwd, 'app', f),
    path.join(cwd, 'src', f),
    path.join(cwd, f)
  ])

  for (const cssFile of cssFiles) {
    if (fs.existsSync(cssFile)) {
      const content = fs.readFileSync(cssFile, 'utf-8')
      if (
        content.includes('@import "tailwindcss"') ||
        content.includes("@import 'tailwindcss'") ||
        content.includes('@theme')
      ) {
        return true
      }
    }
  }

  const postcssFiles = ['postcss.config.js', 'postcss.config.mjs', 'postcss.config.cjs']
  for (const f of postcssFiles) {
    if (fs.existsSync(path.join(cwd, f))) {
      const content = fs.readFileSync(path.join(cwd, f), 'utf-8')
      if (content.includes('tailwindcss') || content.includes('@tailwindcss')) {
        return true
      }
    }
  }

  return false
}
